export default __webpack_public_path__ + "static/media/inventMgmt3Full.00865df1.png";